import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type ToggleCouponActiveVariables = {
	id: number
	is_active: boolean
}

export const useToggleCouponActiveMutation = () => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: toggleCouponActiveMutation } = useMutation({
		mutationFn: ({ id, is_active }: ToggleCouponActiveVariables) => {
			return axiosPrivate.patch(apiRoutes.coupon(String(id)), { is_active })
		},
		onSuccess: (_data, { is_active }) => {
			useToast({
				type: 'success',
				message: is_active ? t('Coupon activated') : t('Coupon deactivated')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.coupons.all })
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return { toggleCouponActiveMutation }
}
